import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

var _ = require('lodash');
import { ToastContainer, toast } from 'react-toastify';
import {CopyToClipboard} from 'react-copy-to-clipboard';
var moment = require('moment');
import DayPicker, { DateUtils } from 'react-day-picker';

import {
  offsetDateForBrowser
} from '../../../shared/timeZoneLogic';
import { AVAILABILITY_DISCLAIMER, holdDatesHeader } from '../../OfferEditUI/utils/buildHoldDatesText';

const formatDate = (time) => {
  return moment(time).format("MM/DD/YY");
}

export const buildHoldGroupDatesText = (holdGroup, venueSelected, makeUnavailable, appendAvailabilityDisclaimer) => {
  const lines = (holdGroup.hold_group_entries || [])
    .filter((holdGroupEntry) => {
      if (holdGroupEntry._destroy){
        return false;
      }
      const hasConfirmWithinHold = (holdGroupEntry.hold.hold_availability || []).some(availity => availity.is_confirm);
      if (makeUnavailable && hasConfirmWithinHold) {
        return false;
      }
      return true;
    })
    .sort((a, b) => a.hold.start_time - b.hold.start_time)
    .map(holdGroupEntry => `${holdGroupEntry.hold.start_time.toDateString()} H${holdGroupEntry.hold.position}`);

  if (lines.length === 0) {
    return '';
  }

  const header = holdDatesHeader(venueSelected?.name);
  const prefix = header ? [header] : [];
  const suffix = appendAvailabilityDisclaimer ? [AVAILABILITY_DISCLAIMER] : [];
  return [...prefix, ...lines, ...suffix].join("\n");
}

const HoldPositionPicker = ({
  csrfToken,
  team,
  venueSelected,
  holdGroup,
  holdGroupCalendarDateClicked,
  holdGroupDates,
  holdGroupHoldPositionUpdated,
  holdGroupHoldRemoved,
  holdPositionTargetToggled,
  fetchHoldAvailability,
  calendarRef,
  calendarStartDate,
  makeUnavailable,
  setMakeUnavailable,
  selectedRooms,
}) => {
  useEffect(() => {
    holdGroupDates.forEach((date) => {
      fetchHoldAvailability(team, selectedRooms.map(r => r.value), date);
    });
  }, [selectedRooms])

  const handleDayClick = (date, modifiers, e) => {
    if (e && e.shiftKey && holdGroupDates.length > 0) {
      const lastDate = holdGroupDates[holdGroupDates.length - 1];
      const startDate = lastDate < date ? lastDate : date;
      const endDate = lastDate < date ? date : lastDate;

      const rangeDates = [];
      const currentDate = new Date(startDate);
      while (currentDate <= endDate) {
        rangeDates.push(new Date(currentDate));
        currentDate.setDate(currentDate.getDate() + 1);
      }

      rangeDates.forEach((rangeDate) => {
        const isAlreadySelected = holdGroupDates.some(selectedDate =>
          selectedDate.toDateString() === rangeDate.toDateString()
        );
        if (!isAlreadySelected) {
          holdGroupCalendarDateClicked(rangeDate, false);
          fetchHoldAvailability(team, selectedRooms.map(r => r.value), rangeDate);
        }
      });
    } else {
      holdGroupCalendarDateClicked(date, modifiers.selected);
      fetchHoldAvailability(team, selectedRooms.map(r => r.value), date);
    }
  };

  return(
    <div className="form-group">
      <div className='form-row'>
        <div className="col-12 col-md-6">
          <div style={{"marginLeft": "-18px", "position": "relative", "zIndex": 2}}>
            <DayPicker
              month={calendarStartDate}
              onMonthChange={(date) => {
                if(calendarRef && Object.keys(calendarRef).length > 0){
                  calendarRef.getApi().gotoDate(date);
                }
              }}
              selectedDays={holdGroupDates}
              onDayClick={handleDayClick} />
          </div>
        </div>
        <div className="col-12 col-md-6">
          <div className="custom-control custom-control-inline custom-checkbox custom-checkbox-table">
              <input
                  type="checkbox"
                  className="custom-control-input"
                  id="check-no-confirms"
                  checked={makeUnavailable}
                  onChange={() => setMakeUnavailable(!makeUnavailable)}
              />
              <label
                  className="custom-control-label"
                  style={{"fontSize": "14px", "marginLeft": "5px"}}
                  htmlFor="check-no-confirms">
                  Exclude dates with confirms
              </label>
          </div>
          <div className="table-responsive">
          <table style={{'marginTop': "16px", "tableLayout": "fixed"}}
                  className="table table-borderless table-sm microtable text-muted">
            <colgroup>
              <col span={1} style={{"width": "45%"}} />
              <col span={1} style={{"width": "45%"}} />
              <col span={1} style={{"width": "10%"}} />
            </colgroup>
            <thead>
              <tr>
                <td>Date</td>
                <td>Hold Priority</td>
                <td>&nbsp;</td>
              </tr>
            </thead>
            <tbody>
              {
                (holdGroup.hold_group_entries || [])
                  .filter((holdGroupEntry) => !holdGroupEntry._destroy)
                  .sort((a, b) => a.hold.start_time - b.hold.start_time)
                  .map((holdGroupEntry, index) => (
                    <tr key={index}>
                      <td>
                        <div
                          className="d-inline-flex align-items-center badge badge-light"
                          style={{
                            fontSize: 12,
                            fontWeight: "normal",
                            padding: 0,
                            borderRadius: 8,
                            border: "2px solid var(--od-c-ced4da, #CED4DA)",
                            backgroundColor: "var(--od-c-f3f3f3, #F3F3F3)",
                            color: "var(--od-c-6c757d, #6c757d)",
                            cursor: "pointer",
                            minWidth: "fit-content",
                            width: "-webkit-fill-available",
                            justifyContent: "space-between",
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            holdPositionTargetToggled(holdGroupEntry.hold.start_time);
                          }}
                        >
                          <span style={{
                            margin: "6px 6px",
                          }}>{formatDate(holdGroupEntry.hold.start_time)}</span>
                          <i
                            className={`fas fa-bullseye-arrow ml-2`}
                            style={{
                              color: holdGroupEntry.hold.is_target ? '#007bff' : 'var(--od-c-dee2e6, #dee2e6)',
                              fontSize: '14px',
                              padding: "6px 6px",
                              borderLeft: "2px solid var(--od-c-ced4da, #CED4DA)",
                              backgroundColor: "var(--od-c-ffffff, white)",
                              borderRadius: "0 6px 6px 0",
                            }}
                          />
                        </div>
                      </td>
                      <td>
                        <select value={holdGroupEntry.hold.position}
                                onChange={
                                  (e) => {
                                    e.preventDefault();
                                    holdGroupHoldPositionUpdated(holdGroupEntry.hold.start_time, e.target.value);
                                  }
                                }
                                className="form-control form-control-sm"
                                style={
                                  {
                                    "fontSize": "12px",
                                    "width": "100%",
                                    "borderRadius": "8px",
                                  }
                                }>
                          {(holdGroupEntry.hold.hold_availability || []).length > 0
                            ? (holdGroupEntry.hold.hold_availability || []).map(function(availity, index){
                                if (makeUnavailable && availity.is_confirm) {
                                  return (
                                      <option key={index}
                                              disabled={true}
                                              value={availity.position}>
                                          {`${availity.hold_title || 'Unavailable'}`}
                                      </option>
                                  );
                              } else {
                                return (
                                  <option key={index}
                                          disabled={availity.hold_title !== null}
                                          value={availity.position}>
                                    {availity.hold_title === null ? (
                                      "Hold " + availity.position + " - Available"
                                    ) : (
                                      "Hold " + availity.position + " - " + availity.hold_title
                                    )}
                                  </option>
                                )
                              }
                            })
                            : [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20].map(function(priority, index){
                                return <option key={index} value={priority}>{"Hold " + priority}</option>
                              })
                          }
                        </select>
                      </td>
                      <td className="pt-2">
                        <a className="text-muted"
                            onClick={
                              (e) => {
                                e.preventDefault();
                                holdGroupHoldRemoved(holdGroupEntry.hold.start_time);
                              }
                            }
                            href="#">
                          <i className="fas fa-times-circle"></i>
                        </a>
                      </td>
                    </tr>
                  ))
              }
              <tr>
                <td>
                  <input type="text"
                          className="form-control form-control-sm"
                          style={
                            {
                              "fontSize": "12px",
                              "borderRadius": "8px",
                              "background": "var(--od-c-ffffff, white)",
                              "opacity": "0.5",
                              "border": "2px solid var(--od-c-f5f5f5, #f5f5f5)"
                            }
                          }
                          placeholder="Select a date"
                          disabled={true} />
                </td>
                <td>
                  <select value={1}
                          className="form-control form-control-sm"
                          disabled={true}
                          style={
                            {
                              "background": "var(--od-c-ffffff, white)",
                              "fontSize": "12px",
                              "width": "100%",
                              "border": "2px solid var(--od-c-f5f5f5, #f5f5f5)",
                              "opacity": "0.5",
                              "borderRadius": "8px",
                            }
                          }>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20].map(function(priority, index){
                      return <option key={index} value={priority}>{"Hold " + priority}</option>
                    })}
                  </select>
                </td>
                <td>
                  &nbsp;
                </td>
              </tr>
            </tbody>
          </table>
          </div>
          <p className="mb-0 ml-1 text-muted" style={{"fontSize": "10px"}}>
            You can select as many dates as you want.
          </p>
          <div className="mt-2 ml-1">
            <CopyToClipboard
              text={buildHoldGroupDatesText(holdGroup, venueSelected, makeUnavailable, team.append_availability_disclaimer_to_hold_dates)}
              options={{ format: 'text/plain' }}
              onCopy={
                () => {
                  toast.success("Copied hold dates to clipboard", {
                    position: toast.POSITION.TOP_CENTER,
                    draggable: false,
                    closeOnClick: false,
                    autoClose: 5000,
                    hideProgressBar: true
                  });
                }
              }>
              <a href="#" className="small" onClick={(e) => e.preventDefault()}>
                <i className="fal fa-clipboard"></i>&nbsp;
                Copy hold dates to clipboard
              </a>
            </CopyToClipboard>
          </div>
        </div>
      </div>
    </div>
  )
};

HoldPositionPicker.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  venueSelected: PropTypes.object,
  holdGroup: PropTypes.object,
  holdGroupCalendarDateClicked: PropTypes.func.isRequired,
  holdGroupDates: PropTypes.array,
  holdGroupHoldPositionUpdated: PropTypes.func.isRequired,
  holdGroupHoldRemoved: PropTypes.func.isRequired,
  holdPositionTargetToggled: PropTypes.func.isRequired,
  fetchHoldAvailability: PropTypes.func.isRequired,
  calendarRef: PropTypes.object,
  calendarStartDate: PropTypes.instanceOf(Date),
  makeUnavailable: PropTypes.bool,
  setMakeUnavailable: PropTypes.func.isRequired,
  selectedRooms: PropTypes.array,
};

export default HoldPositionPicker;
